import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { Router, RouterModule } from '@angular/router';

import { PipesModule } from '../../modules/pipes/pipes.module';
import { ThemesService } from '../../services/themes.service';

@Component({
  selector: 'app-theme-switcher',
  templateUrl: './theme-switcher.component.html',
  styleUrls: ['./theme-switcher.component.scss'],
  standalone: true,
  imports: [MatSlideToggleModule, RouterModule, PipesModule],
})
export class ThemeSwitcherComponent implements OnInit, OnDestroy {
  @Input()
  public sliderText = '';

  constructor(
    public themesService: ThemesService,
    public router: Router,
  ) {}

  ngOnInit(): void {}

  ngOnDestroy(): void {}
}
